module.exports = __webpack_public_path__ + "static/media/company-setting.91e7cab6.svg";